module.exports = __webpack_public_path__ + "static/media/hat.18799d26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hat.png
// module id = 365
// module chunks = 42